module.exports = _dll_vendors5_67844dd1cc899c2ca193;